<template>
  <header>
    <nav class="uk-navbar-container" uk-navbar>
      <div class="uk-navbar-left">
        <ul class="uk-navbar-nav">
          <li>
            <router-link :to="{ name: 'Home' }"> ホーム </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Admin' }"> 管理者ページ </router-link>
          </li>
          <li v-if="$store.state.login_user">
            <router-link :to="{ name: 'Home' }" @click="logout">
              ログアウト
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <div>
      <div
        class="uk-background-cover uk-height-medium uk-panel uk-flex uk-flex-center uk-flex-middle header_img"
        uk-parallax="bgy: -200"
      >
        <p class="f30 text_shadow text_white">卓球練習検索</p>
      </div>
    </div>
  </header>
  <transition name="back" appear>
    <router-view />
  </transition>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'App',
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapActions(['fetchItems', 'logout']),
  },
}
</script>

<style lang="scss">
.header_img {
  background-image: url('~@/assets/img/header.jpg');
}


.back-leave-active {
  animation: back 1s;
}

@keyframes back {
  from {
    opacity: 1;
    transform: translate(0,0);
  }
  to {
    opacity: 0;
    transform: translate(-200px,0);
  }
}
</style>
